import makeApiCall from "../master/axiosIndex";
const STATIC_FILES_DATA = {
  docKeys: [
    {
      order: 0,
      module: "Payment",
      moduleFileType: "signature.png",
    },
  ],
};

const paymentApis = {
  submitPayment: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/payment/submitPayment",
      method: "post",
      data,
    }),
  runPayment: (data: any): Promise<any> =>
    makeApiCall<any>({
      url: "/payment/runPayment",
      method: "post",
      data,
    }),
  fetchAllPendingApprovalPayments: (): Promise<any> =>
    makeApiCall<any>({
      url: "/payment/fetchAllPendingApprovalPayments",
      method: "get",
    }),
  fetchPayment: (paymentNumber: string): Promise<any> =>
    makeApiCall<any>({
      url: `/payment/fetchPayment?paymentNumber=${paymentNumber}`,
      method: "get",
    }),
  approvePayment: (paymentNumber: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      paymentNumber,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "patch",
      url: `/payment/approvePayment`,
      data: formData,
    });
  },
  disapprovePayment: (paymentNumber: string, reason: string, files: File[] = []): Promise<any> => {
    const formData = new FormData();

    const requestBody = {
      paymentNumber,
      reason,
      filesData: STATIC_FILES_DATA,
    };

    formData.append("request", JSON.stringify(requestBody));
    files.forEach((file) => formData.append("files", file));

    return makeApiCall<any>({
      method: "patch",
      url: `/payment/disapprovePayment`,
      data: formData,
    });
  },

  fetchAllPendingRunPayments: (): Promise<any> =>
    makeApiCall<any>({
      url: "/payment/fetchAllPendingRunPayments",
      method: "get",
    }),
  fetchAllPayments: (): Promise<any> =>
    makeApiCall<any>({
      url: "/payment/fetchAllPayments",
      method: "get",
    }),
  fetchAllInvoicePaymentLines: (invoiceNumber: any): Promise<any> =>
    makeApiCall<any>({
      url: `/payment/fetchAllInvoicePaymentLines?invoiceNumber=${invoiceNumber}`,
      method: "get",
    }),
  fetchAllOrgUnUtilizedCreditDebitNotes: (supplierId: any): Promise<any> =>
    makeApiCall<any>({
      url: `/credit-debit-note/fetchAllOrgUnUtilizedCreditDebitNotes?supplierId=${supplierId}`,
      method: "get",
    }),
  fetchPayableInvoicesForPaymentsWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/billing/fetchPayableInvoicesForPaymentsWithPagination",
      method: "get",
      params,
    }),
  fetchUserPendingApprovalPaymentsWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/payment/fetchUserPendingApprovalPaymentsWithPagination",
      method: "get",
      params,
    }),
  fetchAllPendingRunPaymentsWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/payment/fetchAllPendingRunPaymentsWithPagination",
      method: "get",
      params,
    }),
  fetchUniqueSuppliersOfPayableInvoices: (): Promise<any> =>
    makeApiCall<any>({
      url: "/billing/fetchUniqueSuppliersOfPayableInvoices",
      method: "get",
    }),
  fetchPayableInvoicesWidgetCounts: (): Promise<any> =>
    makeApiCall<any>({
      url: "/billing/fetchPayableInvoicesWidgetCounts",
      method: "get",
    }),
  fetchAllPaidInvoicesWithPagination: (params: any): Promise<any> =>
    makeApiCall<any>({
      url: "/billing/fetchAllPaidInvoicesWithPagination",
      method: "get",
      params,
    }),
  fetchStatusFilterOptions: (): Promise<any> =>
    makeApiCall<any>({
      method: "get",
      url: `/purchase-request/status`,
    }),
};

export default paymentApis;
